import { Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import './CoverPicture.scss';
import { FormPictureField } from './FormPictureField';

export const CoverPicture = () => {
  const form = Form.useFormInstance<Partial<PackResponse>>();
  const horizontalCoverPicture = Form.useWatch<PictureView>(
    'horizontalCoverPicture',
    form
  );
  const verticalCoverPicture = Form.useWatch<PictureView>(
    'verticalCoverPicture',
    form
  );
  const hotelId = Form.useWatch('hotelId', form);

  return (
    <SCard title="Cover picture" className="scard-cover-with-pictures">
      <div className="staycation-card__container">
        <div>
          <div className="staycation-card__title">Horizontal cover</div>
          <div className="staycation-card__subtitle">
            Picture used to display the cover in most cases, notably the hotel
            cards and the cover on the hotel page on desktop
          </div>
        </div>
        <FormPictureField
          name="horizontalCoverPicture"
          sectionTitle="Horizontal cover"
          hotelId={hotelId}
          maxPictures={1}
          value={horizontalCoverPicture}
        />
      </div>

      <div className="staycation-card__container">
        <div>
          <div className="staycation-card__title">Vertical cover</div>
          <div className="staycation-card__subtitle">
            Picture used to display the cover in some cases, notably for daytime
            package and the cover on the hotel page on mobile
          </div>
        </div>
        <FormPictureField
          name="verticalCoverPicture"
          sectionTitle="Vertical cover"
          hotelId={hotelId}
          maxPictures={1}
          value={verticalCoverPicture}
        />
      </div>
    </SCard>
  );
};
